import confirm from "../Dialogs/confirm";
import showMessage from "../Dialogs/showMessage";
import { LeasmanContractType } from "./Domain";

const RESTRICTED_CONTRACT_TYPES: LeasmanContractType[] = ["Service", "Supplementary"];

export const isContractServiceTypeRestricted = (contractType?: LeasmanContractType) =>
	!!contractType && RESTRICTED_CONTRACT_TYPES.includes(contractType);

/**
 * Returns/Anlieferungen, Kundenaufträge und Kaufpreisanfragen für Fahrzeuge mit Service- oder
 * Ergänzungsvertrag dürfen nur von einem AldManager ausgelöst werden, der die vertraglichen
 * Konsequenzen akzeptiert. Users without the role are blocked outright, AldManagers only see a
 * warning with the option to continue. The backend enforces this restriction regardless of the
 * outcome here - this check only provides early UI feedback.
 *
 * Returns true if the caller may proceed with the restricted action.
 */
const confirmContractServiceTypeRestriction = async (
	contractType: LeasmanContractType | undefined,
	isAldManager: boolean
): Promise<boolean> => {
	if (!isContractServiceTypeRestricted(contractType)) {
		return true;
	}

	if (!isAldManager) {
		await showMessage({
			title: "Aktion nicht möglich",
			message: "Für Fahrzeuge mit Service- oder Ergänzungsvertrag ist diese Aktion nur für die Remarketing Logistik Abteilung verfügbar."
		});

		return false;
	}

	const result = await confirm(
		"Dieses Fahrzeug hat einen Service- oder Ergänzungsvertrag. Bitte stellen Sie sicher, dass Ihnen die vertraglichen Konsequenzen bewusst sind, bevor Sie fortfahren.",
		"Warnung"
	);

	return result.ok === true;
};

export default confirmContractServiceTypeRestriction;
